import { createClient, Environment } from '@kameleoon/react-sdk';

const siteCode = process.env.REACT_APP_KAMELEOON_SITE_CODE;
const isProduction = process.env.REACT_APP_PAYPAIR_ENV === 'production';

export const kameleoonClient = createClient({
  siteCode: siteCode,
  stubMode: false,
  configuration: {
    updateInterval: 60, // Update configuration every 60 minutes
    environment: isProduction ? Environment.Production : Environment.Staging,
    trackingInterval: 1000, // Send tracking requests every 1000ms
  },
});

